export { default } from "./ColorsProvider";
